<template>

    <div>

        <h3 class="mb-2">Registrera behandling</h3>
        <div class="custom-info pt-0 mb-6">Här registrerar du en behandling för den anställde.</div>

        <div class="row">
            <div class="col-24 col-md-24">

                <div class="custom-form-section">

                    <div class="row">

                        <div class="col-4">

                            <div class="custom-form-group">
                                <label class="form-label" for="punch-register-date">Behandlingsdatum</label>
                                    <datepicker-new
                                        :input-class="{
                                            'form-control': true,
                                            'is-invalid': getError('treatment_at')
                                        }"
                                        placeholder="Välj"
                                        :language="former.datepicker.locale"
                                        :use-utc="true"
                                        :monday-first="true"
                                        :disabled-dates="disabledDates"
                                        :format="formerDateFormat"
                                        v-model="form.treatment_at"
                                    />
                                <div class="invalid-feedback">Välj ett datum.</div>
                            </div>

                        </div>

                        <div class="col-5">

                            <input-text
                                type="text"
                                name="signature_key"
                                label="Massörskod"
                                v-model="form.signature_key"
                                class="mb-0"
                                error="Vänligen ange korrekt massörskod."
                            />
                            <div class="my-2">eller</div>
                            <div class="custom-form-group mb-0">
                                <v-select
                                    label="name_clinic"
                                    placeholder="Sök massör"
                                    :options="clinics"
                                    :reduce="clinics => clinics.clinic_id"
                                    v-model="form.clinic_id"
                                />
                            </div>

                            <div class="invalid-feedback" v-if="getError('signature_key') || getError('clinic_id')">
                                Ange en korrekt massörskod eller sök fram en massör i listan.
                            </div>

                        </div>

                        <div class="col-5" v-if="contract.subscription.type === 'unlimited'">
                            <label class="form-label">Sen avbokning / no show</label>
                            <input-check-radio
                                type="checkbox"
                                name="no_show"
                                v-model="form.no_show"
                                :options="[
                                    {value: true, label: 'Debitera'},
                                ]"
                                formGroupClass="pt-4"
                            />

                        </div>

                        <div class="col-4">
                            <label class="form-label">SMS med enkät</label>
                            <input-check-radio
                                type="checkbox"
                                name="send_survey_sms"
                                v-model="form.send_survey_sms"
                                :options="[
                                    {value: true, label: 'Skicka'},
                                ]"
                                formGroupClass="pt-4"
                            />

                        </div>

                        <div class="col-6" v-if="employee.company.employee_part_payment_type === 'allowance_or_salary'">
                            <label class="form-label">Delbetalning för anställd ({{ partPaymentAmount}} kr)?</label>
                            <div class="form-check pt-1">
                                <input class="form-check-input" type="radio" name="customer-payment" id="customer-payment-wellness" value="allowance" v-model="form.part_payment_type">
                                <label class="form-check-label" for="customer-payment-wellness">Friskvårdsbidrag</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="customer-payment" id="customer-payment-salary" value="salary" v-model="form.part_payment_type">
                                <label class="form-check-label" for="customer-payment-salary">Löneavdrag</label>
                            </div>
                        </div>

                        <div class="col-6" v-else>

                        </div>

                        


                    </div>

                    <div class="d-flex justify-content-end">
                        <button class="btn btn-primary" @click="posterPost()" v-if="!form.treatment_token">
                            Fortsätt
                        </button>
                    </div>

                    <div class="alert-danger" v-if="former.unhandled_error">
                        Något gick fel, försök igen eller kontakta support.
                    </div>

                </div>

            </div>

            <div class="col-24 col-md-24" v-if="form.treatment_token">
                <div class="alert alert-primary">
                    <h3>Är följande korrekt?</h3>
                    <p>
                        <b>Massör:</b> {{ clinic.name_person }}<br>
                        <b>Mottagning:</b> {{ clinic.name_clinic }}
                    </p>
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-info me-4" @click="abort()">Nej, ändra</button>
                        <button class="btn btn-primary" @click="posterPost()">Bekräfta</button>
                    </div>
                </div>

            </div>

        </div>

    </div>

</template>

<script>

import poster from '../../../../shared/mixins/poster'
import { activeContract } from '../../../../shared/methods/contract-filter'

import vSelect from 'vue-select'
import moment from 'moment'

export default {

    mixins: [
        poster
    ],

    components: {
        vSelect
    },

    props: {
        employee: {
            required: true
        },
        clinics: {
            required: true
        },
        first_creatable_treatment_date: {
            required: true
        }
    },

    data () {
        return {
            form: {
                treatment_at: null,
                signature_key: '',
                clinic_id: null,
                part_payment_type: this.employee.company.employee_part_payment_type === 'allowance_or_salary' ? 'allowance' : null,
                send_survey_sms: true,
                no_show: false,
                treatment_token: null
            },

            clinic: {
                name_person: '',
                name_clinic: ''
            },

            validated: false
        }
    },

    computed: {
        posterUrl () {
            return '/employees/' + this.employee.id + '/treatments/' + (this.form.treatment_token ? 'store' : 'validate')
        },

        posterData () {
            return this.form
        },

        contract () {
            return this.activeContract(this.employee.company.contracts)
        },

        partPaymentAmount () {
            if (this.employee.part_payment_exception) {
                return this.employee.part_payment_amount
            }
            return this.employee.company.employee_part_payment_amount
        },

        disabledDates () {
            const activeContract = this.contract

            const first_creatable_treatment_date = this.first_creatable_treatment_date

            const to = activeContract.starts_at

            let from = null
            if (activeContract && activeContract.ends_at) {
                from = activeContract.ends_at
            }

            return {
                customPredictor (date) {
                    if (first_creatable_treatment_date && moment(date).isBefore(moment(first_creatable_treatment_date))) {
                        return true
                    }

                    if (to && moment(date).isSameOrBefore(moment(to))) {
                        return true
                    }
                    if (from && moment(date).isAfter(moment(from).endOf('day'))) {
                        return true
                    }
                }
            }
        }
    },

    methods: {

        posterSuccess (data) {
            if (data.treatment_token) {
                this.form.treatment_token = data.treatment_token
                this.clinic.name_person = data.clinic.name_person
                this.clinic.name_clinic = data.clinic.name_clinic
                return
            }
            bus.$emit(
                'notify',
                'Behandlingen har registrerats.'
            )
            this.resetForm()
        },

        abort () {
            this.form.treatment_token = null
            this.clinic.name_person = ''
            this.clinic.name_clinic = ''
        },

        resetForm () {
            this.form.treatment_at = null
            this.form.signature_key = ''
            this.form.clinic_id = null
            this.form.send_survey_sms = true
            this.form.treatment_token = null
            this.form.no_show = false
        },

        activeContract: activeContract

    }
}
</script>
